import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import ParcelCarrier from '@/parcels/components/ParcelCarrier/ParcelCarrier'
import ParcelDate from '@/parcels/components/ParcelDate/ParcelDate'
import ParcelDestination from '@/parcels/components/ParcelDestination/ParcelDestination'
import ParcelMethod from '@/parcels/components/ParcelMethod/ParcelMethod'
import ParcelOrigin from '@/parcels/components/ParcelOrigin/ParcelOrigin'
import ParcelPickupDate from '@/parcels/components/ParcelPickupDate/ParcelPickupDate'
import ParcelUserInfo from '@/parcels/components/ParcelUserInfo/ParcelUserInfo'
import { getParcelAddressText } from '@/parcels/helpers/helpers'

import * as Styles from './styles'

const ParcelCardBody = ({
  error,
  recipientAddress,
  destinationAddress,
  senderAddress,
  senderName,
  createdAt,
  modifiedAt,
  itemsQuantity,
  notes,
  customer,
  carrierName,
  carrierLogo,
  shippingMethod,
  email,
  pickupDate,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.ParcelCardBody>
      {error && <Alert type="warning">{t(error)}</Alert>}
      <Styles.ParcelInfo>
        <Styles.ParcelInfoContainer alignItems="flex-start">
          <Styles.OriginAndDestinationContainer>
            <ParcelOrigin addressText={getParcelAddressText(senderAddress, senderName)} /> |
            <ParcelDestination addressText={getParcelAddressText(destinationAddress, destinationAddress?.locality)} />
          </Styles.OriginAndDestinationContainer>
          <ParcelUserInfo customer={customer} recipientAddress={recipientAddress} email={email} />
          <ParcelDate date={createdAt} modified={modifiedAt} />
        </Styles.ParcelInfoContainer>
        <Styles.ParcelInfoContainer alignItems="flex-end">
          <ParcelCarrier
            carrierLogo={carrierLogo}
            carrierName={carrierName}
            carrierServiceName={shippingMethod?.carrier?.service_name}
          />
          <ParcelMethod shippingMethod={shippingMethod} itemsQuantity={itemsQuantity} notes={notes} />
          <ParcelPickupDate date={pickupDate} />
        </Styles.ParcelInfoContainer>
      </Styles.ParcelInfo>
    </Styles.ParcelCardBody>
  )
}

export default ParcelCardBody
